import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedModule } from '@modules/shared.module';
import { NavigationService } from '@services/navigation-service/navigation-service.service';

@Component({
    selector: 'app-slide-filter-advanced',
    imports: [SharedModule],
    template: `
    <mat-slide-toggle (change)="emitirCambio($event)"> Filtros Avanzados </mat-slide-toggle>
  `,
    styleUrls: ['./slide-filter-advanced.component.css']
})
export class SlideFilterAdvancedComponent {
  private navigationService = inject(NavigationService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);


  @Output() change = new EventEmitter<boolean>();
  @Input() disabled!: any
  @Input() isDialogClose = false
  goBack(): void {
    if (this.isDialogClose)
      this.isDialogClose = !this.isDialogClose
    else
      this.navigationService.back();
  }

  emitirCambio(event: any) {
    this.change.emit(event.checked);
  }
}
